<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- {{faculties}} -->
        <v-card class="box">
            <!-- <v-card-title>
                <h3>Assign Co-ordinator</h3>
            </v-card-title> -->
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Assign Co-ordinator</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <!-- <v-card-text> -->
            <center> <a href="#coord_list" v-if="coordinator_list!=null" style="opacity: 0.5;">(Cleck here to get
                    co-ordinator list)</a> </center>
            <span v-if="std_data">
                <v-row dense align="center" justify="center">
                    <v-col md="3" sm="3">
                        <v-autocomplete rounded dense v-model="faculty" :items="faculties" item-text="faculty_name"
                            label="Select Faculty" return-object outlined hint="Assign Co-ordinator from Faculty list"
                            persistent-hint></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense class="toolbar" v-if="std_data.length!=0">
                    <v-col sm="3" cols="12" md="3" class="m-0 p-0 p-none">
                        <strong>Standard</strong>
                    </v-col>
                    <v-col md="9" cols="12" sm="12" class="m-0 p-0 p-none">
                        <strong>Division</strong>
                    </v-col>
                </v-row>
                <v-row dense v-for="(std,index) in std_data" :key="std.std_id" :class="(index % 2==0?'even':'odd')">
                    <v-col md="3" sm="3" cols="12" class="m-0 p-0">
                        <v-checkbox dense :label="std.std_name" v-model="std.curr"
                            @change="addDivs(std.std_div_list,std.curr)"></v-checkbox>
                        <!-- {{std.std_div_list}} -->
                    </v-col>
                    <v-col md="9" sm="3" cols="12" class="m-0 p-0">
                        <v-row dense class="p- m-0 p-none">
                            <span class="mr-2" v-for="div in std.std_div_list" :key="div.div_id">
                                <v-checkbox dense v-model="div_id" :label="div.div_name"
                                    :value="div.div_id"></v-checkbox>
                            </span>
                        </v-row>
                    </v-col>
                </v-row>
                <v-row dense align="center" justify="center">
                    <v-col class="m-0 p-0" md="3" sm="3">
                        <v-btn @click="assignCoordinator" :loading="add_coord_load" class="button">Assign</v-btn>
                    </v-col>
                </v-row>
            </span>
            <!-- </v-card-text> -->
        </v-card>
        <!-- {{div_id}} -->
        <!-- {{coordinator_list}} -->
        <template>
            <v-card class="box" v-if="coordinator_list!=null" id="coord_list">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title> Co-ordinators</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-toolbar flat dense>
                    <!-- <v-card-title> -->
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    <!-- </v-card-title> -->
                </v-toolbar>
                <!-- <v-card-text> -->
                <v-data-table :headers="coordinator_list_headers" :items="coordinator_list" :sort-desc="[false, true]"
                    :search="search" multi-sort class="elevation-1 mytable" dense>
                    <template v-slot:item.assign_corrdinator="{ item }">
                        <v-autocomplete v-model="item.corrdinator" :items="faculties" dense outlined rounded
                            class="pt-2 pb-none" item-text="faculty_name"
                            :label="item.corrdinator!=null?'':'Select Faculty'" return-object
                            @change="editCoordinator(item)" :loading="edit_coord_load"></v-autocomplete>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn small rounded icon color="error" outlined>
                            <v-icon color="error" small @click="removeCoordinator(item)" v-if="item.corrdinator!=null">
                                mdi-delete
                            </v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
                <!-- </v-card-text> -->
            </v-card>
        </template>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },

        data: () => ({
            snackbar_msg: "",
            snackbar: false,
            color: "",
            faculties: null,
            // extraBreadcrumbItems: [
               

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            cay: null,
            std_data: null,
            div_id: [],
            faculty: null,
            coordinator_list: null,
            coordinator_list_headers: [
                { text: "Standard", value: "div_std" },
                { text: "Division", value: "div_name" },
                { text: "Class Teacher", value: "class_teacher" },
                { text: "Co-ordinator", value: "corrdinator.faculty_name" },
                { text: "Edit Co-ordinator", value: "assign_corrdinator" },
                { text: "Remove Co-ordinator", value: "action", align: "center" },
            ],
            search: "",
            edit_coord_load: false,
            add_coord_load: false,
            del_coord_load: false,
        }),
        watch: {},
        methods: {
            removeCoordinator(item) {
                this.del_coord_load = true;
                const formData = {
                    div_off_id: item.div_off_id,
                    faculty_id: item.corrdinator.faculty_id,
                };
                axios
                    .post("/admission/removeCoordinator", formData)
                    .then((res) => {
                        this.showSnackbar("#4CAF50", "Assigned successfully!!!");
                        item.corrdinator = null;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.del_coord_load = false;
                    });
            },
            editCoordinator(item) {
                // alert(item.faculty_id)
                this.edit_coord_load = true;
                const formData = {
                    div_off_id: item.div_off_id,
                    faculty_id: item.corrdinator.faculty_id,
                };
                axios
                    .post("/admission/editCoordinator", formData)
                    .then((res) => {
                        this.showSnackbar("#4CAF50", "Assigned successfully!!!");
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.edit_coord_load = false;
                    });
            },
            assignCoordinator() {
                if (this.faculty == null || this.div_id.length == 0) {
                    this.showSnackbar("#b71c1c", "Please select faculty and atleast one division!!!");
                    return;
                }
                this.add_coord_load = true;
                const formData = {
                    faculty_id: this.faculty.faculty_id,
                    div_id_list: this.div_id,
                };
                axios
                    .post("/admission/add_assign_coordinator", formData)
                    .then((res) => {
                        this.showSnackbar("#4CAF50", "Assigned successfully!!!");
                        this.coordinator_list = res.data.coordinator_list;
                        this.div_id = [];
                        for (var i = 0; i < this.std_data.length; i++) {
                            this.std_data[i].curr = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                        this.add_coord_load = false;
                    });
            },
            addDivs(divs, val) {
                for (var i = 0; i < divs.length; i++) {
                    if (val == true) {
                        if (!this.div_id.includes(divs[i].div_id)) this.div_id.push(divs[i].div_id);
                    } else this.div_id.splice(this.div_id.indexOf(divs[i].div_id), 1);
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            // this.edit_slot_faculty_list = res.data.faculties;
            axios
                .post("/admission/assign_coordinator")
                .then((res) => {
                    this.faculties = res.data.faculties;
                    this.cay = res.data.cay;
                    this.std_data = res.data.std_data;
                    this.coordinator_list = res.data.coordinator_list;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                    //this.div_id=184
                });
        },
    };
</script>
<style scoped>
    .even {
        background-color: whitesmoke;
    }
    .odd {
        background-color: white;
    }
    .allot-btn,
    .allot-icon,
    .info-icon {
        transition: 0.3s;
    }
    .allot-btn:hover .allot-icon {
        color: white;
    }
    .allot-btn:hover {
        background-color: #193a9a !important;
        border-color: #193a9a !important;
        color: white;
    }

    .info-icon:hover {
        background-color: #193a9a !important;
        border-color: #193a9a !important;
        color: white;
        border-radius: 100%;
    }
    .table-sub-title {
        margin-left: 1%;
        font-weight: 500;
        color: #999;
    }
    @media print {
        body {
            height: 100%;
            width: 100%;
        }
        .no-display {
            display: none !important;
        }
        .v-data-footer,
        .v-data-footer__select,
        .v-data-footer__pagination {
            display: none !important;
            visibility: hidden !important;
        }
        .v-data-table table,
        .v-data-table__wrapper {
            width: 100% !important;
            display: block !important;
        }

        table,
        th,
        td {
            border-collapse: collapse !important;
            border: 1px solid black !important;
            width: 100%;
            text-align: right !important;
        }
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /*fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: color-mix(in srgb, var(--v-brand-base) 70%, white) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        /* background-color: #0f2027 !important; */
        border-right: 1px solid rgba(255, 255, 255, 0.3);
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
</style>
